import React, { useState, useRef, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { ReactTitle } from '../utils/MetaTags'
import { reverse, orderBy } from 'lodash'
import { capitalize } from '../../decorators/textTools'
import TopicsApi from '../../api/TopicsApi'
import InfiniteLocationList from '../shared/InfiniteLocationList'

const TopicsPage = () => {
  const { t } = useTranslation()
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false)
  const loadingRef = useRef(false)

  const onLoadMore = useCallback((offset, limit) => {
    if (loadingRef.current) return
    loadingRef.current = true
    setLoading(true)

    TopicsApi.getAll({ limit, offset })
      .then((res) => {
        if (res.response && res.response.ok) {
          const newTopics = res.json || []
          setItems((prev) => {
            const existingIds = new Set(prev.map((t) => t.id))
            const unique = newTopics.filter((t) => !existingIds.has(t.id))
            const merged = [...prev, ...unique]
            return reverse(orderBy(merged, ['rank', 'createdAt'], ['desc', 'desc']))
          })
        }
      })
      .finally(() => {
        loadingRef.current = false
        setLoading(false)
      })
  }, [])

  return (
    <div className='topics'>
      <ReactTitle title={`${capitalize(global.siteTitle)} - ${t('meta.allTopics')}`} />

      <InfiniteLocationList
        limit={9}
        items={items}
        itemsLoading={loading}
        onLoadMore={onLoadMore}
        itemType='topic'
        header={t('home.chooseConvo')}
        transparentHeader
      />
    </div>
  )
}

export default TopicsPage
